<template>
	<div class="useri">

		<div class="useri_left" v-if="device !== 'mobile'">
			<div class="useril_sp1"><span>用户中心</span></div>

			<div class="useril_a2_mar">
				<a class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/userInfo' }" @click="toUserInfo">个人资料</a>
				<a class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/setPwd' }" @click="toPwd">修改密码</a>
				<a class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/address' }" @click="toAddress">收货地址</a>
			</div>
			<div class="useril_sp1"><span>订单管理</span></div>
			<div class="useril_a2_mar">
				<a class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/car' }" @click="toCar()">我的购物车</a>
				<a class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/orderList' }" @click="toOrderList()">我的订单</a>
				<a class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/fast' }" @click="toFast()">快速下单</a>
			</div>
		</div>
		<div class="useri_left" v-else>
			<el-dropdown trigger="click">
                    <span class="el-useril_sp1-link">
                        用户中心
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/userInfo' }" @click.native="toUserInfo">个人资料</el-dropdown-item>
                        <el-dropdown-item class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/setPwd' }" @click.native="toPwd">修改密码</el-dropdown-item>
                        <el-dropdown-item class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/address' }" @click.native="toAddress">收货地址</el-dropdown-item>
                    </el-dropdown-menu>
            </el-dropdown>
			<el-dropdown trigger="click">
                    <span class="el-useril_sp1-link">
                        订单管理
                        <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/car' }" @click.native="toCar()">我的购物车</el-dropdown-item>
                        <el-dropdown-item class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/orderList' }" @click.native="toOrderList()">我的订单</el-dropdown-item>
                        <el-dropdown-item class="useril_a2" :class="{ 'useril_a2_select' : $route.path === '/fast' }" @click.native="toFast()">快速下单</el-dropdown-item>
                    </el-dropdown-menu>
            </el-dropdown>
		</div>

		<router-view></router-view>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
	export default {
		data() {
			return {
				userInfo:"",
				form: {
					name1: '',
					name2: '',
					phone: '',
					email: ''
				}
			}
		},
		computed: {
			...mapGetters(["device"]),
		},
		watch: {

		},
		created: function() {
			if (this.$store.state.userId != "") {
				this.getUser()
			}
		},
		mounted: function() {

		},
		methods: {
			getUser() {
				var that = this
				that.$post('GetUserModel', {
						UserId: that.$store.state.userId
					})
					.then(function(res) {
						that.userInfo = res.data.ResultData
						that.form.phone = that.userInfo.Mobile
						that.form.name1 = that.userInfo.RealName
						that.form.name2 = that.userInfo.Nick
						that.form.email = that.userInfo.Email 
					})
			},
			submitForm() {
				var that = this
				if(that.form.name1 + that.form.email == ""){
					that.$message.error("请输入更改内容");
					return
				}
				if(that.form.email != ""){
					if(!(/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(that.form.email))){
						that.$message.error("邮箱格式不正确");
						return
					}
				}
				that.$post('UpdateUserInfo', {
						UserId: that.$store.state.userId,
						Nick:that.form.name2,
						Email:that.form.email
					})
					.then(function(res) {
						if (res.data.Success == "true") {
							that.$message({
								message: res.data.Msg,
								type: 'success'
							});
							that.getUser()
						}else{
							that.$message.error(res.data.Msg);
						}
					})
			},
			toPwd() {
				this.$router.push("/setPwd")
			},
			toAddress() {
				this.$router.push("/address")
			},
			toOrderList() {
				this.$router.push("/orderList")
			},
			toFast() {
				this.$router.push("/fast")
			},
			toSetPwd() {
				this.$router.push("/setPwd")
			},
			toUserInfo() {
				this.$router.push("/userInfo")
			},
			toCar() {
				this.$router.push("/car")
			}
		}
	}
</script>
<style scoped>
/* .useri{
	width: 100%;
} */
.useril_sp1{
	background-color: #2b2b2b;
}
.useril_a2_select{
	color: red;
}
</style>
<style lang="scss" scoped src="./mobile.scss" ></style>